import { FC } from 'react';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import {
  composeValidators,
  numberPhoneValidator,
  required,
} from 'helpers/validators';
import { OfUnion } from 'types/common';

const validatePhone = composeValidators(required, numberPhoneValidator);

export const FieldPhoneNumber: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Tel]
> = ({ label, fieldName, proposedValue }) => (
  <FormGroup title={label ?? undefined}>
    <Input
      field={fieldName}
      type="tel"
      initialValue={proposedValue || undefined}
      validate={validatePhone}
    />
  </FormGroup>
);
